<template>
 <div class="pinguns">
     <div v-for="(item,index) in list" :key="index" @click="dailian(item)">
        <img :src="item.user_avatar" alt="">
        <div class="zitui">
            <p>{{item.user_name}}</p>
            
            <span style="color:#545353;">{{item.show_time}}</span>
            <div><span v-if="item.to_user_name"> 回复 <span style="color:rgb(79,92,127)">{{item.to_user_name}}</span>：</span>{{item.content}}</div>
        </div>
        <div v-if="item.children" class="zitssui">
            <comment  :list="item.children"></comment>
          </div>
    </div>
 </div>
</template>
<script>
export default {
  name:'comment',
  props:{
    list:Array
  },
  methods:{
      dailian(item){
          this.$emit("name",item)
      }
  }
};
</script>
<style scoped>
.zitssui{
    width: 100%;
    margin-top: 10px;
}
    .pinguns>div{
      display: flex;
      flex-wrap:wrap;
      align-items: flex-start;
      margin-bottom: 10px;
      width: 100%
  }
  .pinguns>div>img{
      width: 25px;
      height: auto;
  }
  .zitui{
      display: inline-block;
      /* position: relative; */
      width: 80%;
      margin-left: 10px;
      
      /* height: 30px; */
        
  }
  .zitui>p{
      color: rgb(79,92,127);
      display: inline-block;
      width: 100px;
      overflow: hidden;
  }
  .zitui>span:nth-child(2){
      float: right;
      display: inline-block;
  }
  .footer{
      /* position: fixed; */
      bottom: 0;
      width: 100%;
      display: flex;
      flex-wrap:wrap;
      align-items: flex-start;
      /* height: 50px; */
      /* background-color: red; */
  }
  .van-cell{
      margin-top: 0;
  }
</style>
